import { Component, OnInit } from '@angular/core';
import { FooterPagesService } from '../../core/services/footer-pages.service';
import { PanelBarItemModel } from '@progress/kendo-angular-layout';
@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {
  data: any;
  public faqData: any;
  public faqItems: Array<any>;
  constructor(private footerPagesService: FooterPagesService) { }

  ngOnInit() {
    const body = {
      languageCode: localStorage.getItem("language")
    }
    this.footerPagesService.getFaqDetails(body).subscribe(response => {
      if (response) {
        const result = response; //Need to get this details from localstorage
        this.data = result.filter(r => r.componentName === "faq");
        const titleData = this.data.filter(title => title.controlName.includes('title_'));
        const contentData = this.data.filter(content => content.controlName.includes('content_'));
        const faqDataPanel = [];

        for (let i = 0; i < titleData.length; i++) {
          let idStr: string = titleData[i].controlName;
          let panel = {
            id: parseInt(idStr.substring(idStr.lastIndexOf('_') + 1, idStr.length), 10),
            title: titleData[i].controlText,
            content: contentData[i].controlText.split('|')
          };
          faqDataPanel.push(panel);
          idStr = null;
          panel = null;
        }
        faqDataPanel.sort((a, b) => (a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0));
        this.faqData = faqDataPanel;
        this.faqItems = this.setKendoPanelBar();
      }
    })
  }
  setKendoPanelBar() {
    return this.faqData.map(faq => {
      const data = {
        title: faq.title,
        content: faq.content,
        id: faq.id.toString()
      } as PanelBarItemModel;
      return data;
    });
  }
  //#region search functionality
  onChangeFilter(str: string) {
    if (str === '') {
      this.faqItems = this.setKendoPanelBar();
    } else {
      this.faqItems = this.setKendoPanelBar().filter(faq => {
        const faqContent = faq.content.map(s => s).join(', ');
        const totalStr = faq.id + ', ' + faq.title + ', ' + faqContent;
        let getId = '';
        const idLength = faq.id.length;
        if (totalStr.toString().substring(idLength + 1, totalStr.length).includes(str)) {
          getId = totalStr.substring(0, idLength);
        }
        return faq.id === getId;
      });
    }

  }
  //#endregion
}
